import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import AdminHome from "./admin/AdminHome";
import AdminNewsMedia from "./admin/AdminNewsMedia";
import AdminPublications from "./admin/AdminPublications";
import AdminResearch from "./admin/AdminResearch";
import AdminTeam from "./admin/AdminTeam";
import AdminOpportunities from "./admin/AdminOpportunities";
import AdminBooksNews from "./admin/AdminBooksNews";

const AdminDashboard = () => {
  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <h1 className="text-4xl font-bold text-center text-purple-800 mb-6">Admin Dashboard</h1>

      {/* Navigation Tabs */}
      <div className="flex space-x-4 mb-6 border-b-2 pb-2">

        <NavLink
          to="/admin/home"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Home
        </NavLink>

        <NavLink
          to="/admin/news-media"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Media
        </NavLink>

        <NavLink
          to="/admin/publications"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Publications
        </NavLink>

        <NavLink
          to="/admin/research"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Research
        </NavLink>

        <NavLink
          to="/admin/team"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Our Team
        </NavLink>

        <NavLink
          to="/admin/opportunities"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Opportunities
        </NavLink>

        <NavLink
          to="/admin/books-news"
          className={({ isActive }) =>
            `px-4 py-2 rounded ${isActive ? "bg-purple-700 text-white" : "bg-gray-200 text-gray-800"}`
          }
        >
          Books News
        </NavLink>
      </div>

      {/* Routes for Admin Pages */}
      <Routes>
        <Route path="/admin/home" element={<AdminHome />} />
        <Route path="/admin/news-media" element={<AdminNewsMedia />} />
        <Route path="/admin/publications" element={<AdminPublications />} />
        <Route path="/admin/research" element={<AdminResearch />} />
        <Route path="/admin/team" element={<AdminTeam />} />
        <Route path="/admin/opportunities" element={<AdminOpportunities />} />
        <Route path="/admin/books-news" element={<AdminBooksNews />} />
        <Route path="*" element={<p className="text-center">Select a section to manage.</p>} />
      </Routes>
    </div>

  );
};

export default AdminDashboard;
